import { guestLinks } from '@map/components/GuestArea/links';
import useNavigate from '@shared/hooks/useNavigate';

const Diia = () => {
  const provider = 'diia';
  const navigate = useNavigate();

  return {
    provider,
    onClick: () => navigate(guestLinks.diiaAuth()),
  };
};

export default Diia;
